import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "prefixCls", "className", "bordered", "disableCheckered"];
import React from 'react';
import { Code } from './Code';
import { Preview } from './Preview';
import { Toolbar } from './Toolbar';
import { Provider } from './store';
import './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var CODE_PREVIEW_PREFIX = 'w-rcpl';
var Internal = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      children,
      prefixCls = CODE_PREVIEW_PREFIX,
      className,
      bordered = true,
      disableCheckered
    } = props,
    divProps = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [prefixCls, className, bordered ? "w-bordered" : null, disableCheckered ? "w-disable-checkered" : null].filter(Boolean).join(' ').trim();
  return /*#__PURE__*/_jsx("div", _extends({
    ref: ref
  }, divProps, {
    className: cls,
    children: React.Children.map(children, (child, key) => {
      if (! /*#__PURE__*/React.isValidElement(child)) return child;
      return /*#__PURE__*/React.cloneElement(child, _extends({}, child.props, {
        key
      }));
    })
  }));
});
var InternalCodePreview = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(Provider, {
    value: {
      collapse: false
    },
    children: /*#__PURE__*/_jsx(Internal, _extends({}, props, {
      ref: ref
    }))
  });
});
export var CodePreview = InternalCodePreview;
CodePreview.Preview = Preview;
CodePreview.Toolbar = Toolbar;
CodePreview.Code = Code;